import React from 'react'
import * as css from 'styles'
import styled from 'react-emotion'
import propStyles from 'prop-styles'

import View from 'components/View/View'
import FadeIn from 'components/Animated/FadeIn'
import Spinner from './Spinner'

const LoadingWrapper = styled('div')({
  // padding: css.space.xl,
  height: '100%', // height: '400px',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  textAlign: 'center',
  fontSize: css.font.r,
  color: css.color.primary,
  overflow: 'hidden',
},
  ({ height }) => ({
    height: height || '100%',
  }),
  propStyles({
    inline: { display: 'inline-block',}
  })
)

const Message = styled(View)({
  marginTop: css.space.s,
})


const Loading = ({ 
  status = 'Pending',
  children, 
  message, 
  errormessage = 'Failed to load', 
  height, 
  small, 
  medium, 
  inline, 
  nospinner 
}) => {
  return {
    Idle: null,
    Pending: (
      <LoadingWrapper height={height} inline={inline}>
        <FadeIn>
          {!nospinner &&
            <Spinner
              small={small}
              medium={medium}
            />
          }
          {message &&
            <FadeIn delay="200ms">
              <Message>{message}</Message>
            </FadeIn>
          }
        </FadeIn>
      </LoadingWrapper>
    ),
    Success: (
      <div style={{position: 'relative'}}>
        <div style={{ 
          background: css.color.white, 
          position: 'fixed', 
          zIndex: 2, 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          animation: `${css.fadeOut} ${css.speed[3]}ms linear forwards`,
          // animation: `${css.fadeOut} 3s linear forwards`,
          userSelect: 'none',
          pointerEvents: 'none',
        }}/>
        <div style={{position: 'relative', zIndex: 1}}>
          {children}
        </div>
      </div>
    ),
    Error: (
      <LoadingWrapper height={height} inline={inline}>
        <FadeIn>
          <Message color={css.color.gray}>{errormessage}</Message>
        </FadeIn>
      </LoadingWrapper>
    )
  }[status]
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js